import axios from "@src/api/axios";
import { BASE_URL } from "@src/utils";
import { TMissionType, TResMissionInfo } from "../type";

export const getLoungeCode = () => {
  return axios.get<{ item: { code: string } }>(`${BASE_URL}/v4/api/secret-lounges/code`);
};
export const addLoungeCode = (loungeCode: string) => {
  return axios.post(`${BASE_URL}/v4/api/secret-lounges/${loungeCode}`);
};
export const getSecretLoungeMissionInfo = () => {
  return axios.get<{ item: TResMissionInfo }>(`${BASE_URL}/v4/api/secret-lounges`);
};
export const secretLoungeReward = (missionType: TMissionType) => {
  return axios.post(`${BASE_URL}/v4/api/secret-lounges/rewards/${missionType}`);
};
export const secretLoungeApplyForDiscount = () => {
  return axios.put(`${BASE_URL}/v4/api/secret-lounges`);
};
